import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Silhouette = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.91 102.48">
  <G fill={color}>
    <Path d="M62.97,29.93c-1.72-4.53-3.35-8.8-3.73-11.22-.95-5.94,3.03-12.89,3.07-12.96.69-1.18.69-2.64.01-3.82-.68-1.19-1.95-1.92-3.32-1.92H10.9c-1.37,0-2.63.73-3.31,1.92-.68,1.18-.68,2.65,0,3.83.04.07,4.01,7.02,3.07,12.96-.38,2.42-2.01,6.69-3.73,11.22-1.28,3.36-2.62,6.89-3.78,10.42,0,.01-.01.03-.02.04-.07.2-.13.4-.19.6-.12.36-.23.73-.34,1.09-.07.22-.13.43-.2.65-1.41,4.66-2.41,9.25-2.41,13.35,0,12.33,4.18,33.7,7.77,43.85.54,1.53,1.98,2.55,3.6,2.55h19.72v-22.05c1.29.42,2.63.64,3.98.64,1.24,0,2.47-.19,3.67-.55v21.96h19.8c1.62,0,3.06-1.02,3.6-2.55,3.59-10.15,7.77-31.52,7.77-43.85,0-7.92-3.68-17.6-6.94-26.15ZM33.11,31.69c.13-.13.26-.23.4-.32.13-.09.28-.18.43-.24.15-.06.32-.1.48-.14.32-.06.66-.06.99,0,.17.04.32.08.47.14.15.06.31.15.45.24.14.09.27.19.38.32.11.11.23.24.32.38.09.14.17.29.23.45.06.15.11.31.15.47.03.17.05.33.05.5,0,.67-.27,1.32-.75,1.8-.11.13-.26.23-.39.33-.13.09-.28.17-.43.23-.15.06-.3.11-.47.14-.17.04-.33.05-.5.05-.69,0-1.33-.27-1.81-.75-.47-.47-.74-1.12-.74-1.8s.27-1.33.74-1.8ZM38.15,72.39c-1.87,1.4-4.45,1.37-6.28-.09L7.87,53.09c.22-1.75.63-3.72,1.22-5.94,16.16,7.89,33.49,7.81,51.65-.22.79,2.87,1.26,5.33,1.43,7.41l-24.03,18.05Z"/>
  </G>
</Svg>
);
};

export default Silhouette;
